var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],class:`anticon custom anticon-${_vm.name} ${_vm.block !== undefined ? 'block' : ''}`},'i',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }